import api from './api';

export const teacherDeploymentAPI = {
  getOverview: (params?: { academic_year?: string }) =>
    api.get('/sis-integration/teacher-deployment/overview/', { params }),

  getGapAnalysis: (params?: { academic_year?: string }) =>
    api.get('/sis-integration/teacher-deployment/gap-analysis/', { params }),

  getQualifications: () =>
    api.get('/sis-integration/teacher-deployment/qualifications/'),
};
